import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingAccountPayableInvoices';

const PendingAccountPayableInvoices = () => ((orgContainer(InnerComponent)));

export default PendingAccountPayableInvoices;
